import { Container } from "@mui/material";
import BazarImage from "components/BazarImage";
import CategorySectionHeader from "components/CategorySectionHeader";
import ShopLayout1 from "components/layouts/ShopLayout1";
import Navbar from "components/navbar/Navbar";
import { H4, H6, Paragraph, Tiny } from "components/Typography";

const PrivacyPolicy = () => {
  return (
    <ShopLayout1 title="Privacy Policy" navbar={<Navbar />}>
      <Container maxWidth="lg" sx={{ p: 2 }}>
        <CategorySectionHeader title="Privacy Policy" />
        <BazarImage
          alt="privacy policy"
          src={"/assets/images/banners/privacy-policy-banner.png"}
          sx={{ width: "100%", mt: 2 }}
        />

        <Tiny mt={5}>Privacy Policy Last Updated: February 22, 2024 </Tiny>

        <H4 mt={5}>WHO ARE WE</H4>
        <Paragraph mt={1}>
          PC Worth is a premier computer and electronic store that offers a wide
          range of products and services to meet the needs of both individual
          and business customers. With a passion for technology and a commitment
          to providing exceptional customer service, PC Worth has established
          itself as a trusted name in the industry. At PC Worth, we pride
          ourselves on offering the latest and greatest technology products at
          competitive prices. In addition to our product offerings, PC Worth is
          also dedicated to providing exceptional customer service. Our
          knowledgeable and experienced team members are always on hand to help
          you find the right products to meet your needs and answer any
          questions you may have. Visit us today to experience the PC Worth
          difference! Our website address is:{" "}
          <a href="https://www.pcworth.com/">https://www.pcworth.com/</a>
        </Paragraph>

        <H4 mt={5}>PERSONAL INFORMATION WE COLLECT</H4>

        <H6 mt={2}>Device Information</H6>
        <Paragraph>
          When you visit our Site, we automatically collect certain information
          about your device, including details about your web browser, IP
          address, time zone, and some of the cookies installed on your device.
          As you navigate through the Site, we also gather information about the
          web pages or products you view, the websites or search terms that led
          you to the Site, and how you interact with the Site. We refer to this
          information collectively as &quot;Device Information.&quot; We use the
          following technologies to collect Device Information:
        </Paragraph>

        <H6 mt={2}>Cookies:</H6>
        <Paragraph>
          These are data files placed on your device or computer that often
          include an anonymous unique identifier. For more information about
          cookies and how to disable them, please visit
          http://www.allaboutcookies.org. Log Files: These track actions
          occurring on the Site and collect data including your IP address,
          browser type, Internet service provider, referring/exit pages, and
          date/time stamps. Web Beacons, Tags, and Pixels: These are electronic
          files used to record information about how you browse the Site.
        </Paragraph>

        <H6 mt={2}>Web Beacons, Tags, and Pixels:</H6>
        <Paragraph>
          These are electronic files used to record information about how you
          browse the Site.
        </Paragraph>

        <H6 mt={2}>Log Files:</H6>
        <Paragraph>
          These track actions occurring on the Site and collect data including
          your IP address, browser type, Internet service provider,
          referring/exit pages, and date/time stamps.
        </Paragraph>

        <H6 mt={2}>Google User Data:</H6>
        <Paragraph>
          We access, use, store, or share Google user data, including but not
          limited to your primary email and personal information you made
          publicly available, only as necessary to provide the Application`s
          functionality and as described in this Privacy Policy.
        </Paragraph>

        <H4 mt={5}>HOW DO WE USE YOUR PERSONAL INFORMATION?</H4>
        <Paragraph mt={1}>
          To fulfill any orders done through the Site, we use the Order
          Information that we gather generally. This includes handling your
          payment information, setting up shipment, and sending you bills and/or
          order confirmations. We also employ this Order Information to:To
          fulfill any orders done through the Site, we use the Order Information
          that we gather generally. This includes handling your payment
          information, setting up shipment, and sending you bills and/or order
          confirmations. We also employ this Order Information to:
        </Paragraph>
        <Paragraph mt={2}>
          Detect any potential danger or fraud in our orders;
        </Paragraph>
        <Paragraph mt={2}>
          and Whenever it is in keeping with the preferences you have let us
          know about, send you information or advertising about our goods or
          services.
        </Paragraph>
        <Paragraph mt={2}>
          We screen for possible risk and fraud using the Device Information we
          gather, specifically your IP address, and utilize it more broadly to
          enhance and optimize our website (for example, by creating analytics
          about how our users browse and use the website, and to evaluate the
          effectiveness o our marketing and advertising initiatives).
        </Paragraph>

        <H4 mt={5}>DATA RETENTION</H4>
        <Paragraph mt={1}>
          We retain your Order Information for our records to provide you with a
          seamless customer experience, comply with legal obligations, resolve
          disputes, and enforce our agreements. This information is kept for as
          long as necessary to fulfill the purposes for which it was collected,
          including for the duration of our business relationship with you and
          as required by applicable laws. After you place an order through the
          Site, we will maintain your Order Information in our records unless
          and until you request us to delete this information. We periodically
          review the data we hold and securely delete or anonymize information
          that is no longer needed. If you wish to request the deletion of your
          Order Information, please contact us using the contact details
          provided in our Privacy Policy. We will process your request in
          accordance with applicable data protection laws and our internal
          policies. Please note that in some cases, we may be required to retain
          certain information by law or for legitimate business purposes, such
          as to complete transactions, comply with our legal obligations, or
          resolve disputes. In such cases, we will retain your information for
          the period required by law or as necessary for the relevant purposes.
        </Paragraph>

        <H4 mt={5}>DATA PRIVACY CHANGES</H4>
        <Paragraph mb={5}>
          We reserve the right to update or modify this Privacy Policy at any
          time to accommodate new technologies, industry practices, regulatory
          requirements, or for other purposes. Any changes to our privacy
          practices will be posted on this page, and we will indicate the date
          the Privacy Policy was last revised at the top of the page. We
          encourage you to review this Privacy Policy periodically to stay
          informed about how we are protecting the personal information we
          collect. Your continued use of the Site after any changes to this
          Privacy Policy become effective constitutes your acceptance of the
          revised Privacy Policy.
        </Paragraph>

        <H4 mt={5}>SECURITY OF YOUR INFORMATION</H4>
        <Paragraph mt={1} mb={5}>
          We are committed to safeguarding the confidentiality and security of
          your personal information. To achieve this, we employ a combination of
          administrative, technical, and physical security measures. These
          measures include, but are not limited to, encryption, firewalls,
          access controls, and secure data storage facilities. We regularly
          review and update our security practices to protect against
          unauthorized access, disclosure, alteration, or destruction of your
          personal information. Despite our efforts to ensure the security of
          your information, it is important to recognize that no electronic
          transmission over the Internet or information storage technology can
          be guaranteed to be 100% secure. Therefore, while we strive to use
          commercially acceptable means to protect your personal information, we
          cannot guarantee its absolute security. We encourage you to be
          vigilant in protecting your own personal information and to use secure
          passwords, not share your passwords with others, and to change them
          regularly.
        </Paragraph>

        <H4 mt={5}>POLICY FOR CHILDREN</H4>
        <Paragraph mt={1} mb={5}>
          Protecting the privacy of young children is especially important to
          us. Our Site is not designed for or intentionally targeted at children
          under the age of 18. We do not knowingly collect or solicit personal
          information from children under the age of 18. If we become aware that
          we have collected personal information from a child under the age of
          18 without verification of parental consent, we will take steps to
          remove that information from our servers. If you are a parent or
          guardian and believe that your child under the age of 18 has provided
          us with personal information without your consent, please contact us
          immediately using the contact information provided on our contact us
          page. We will take prompt action to investigate and address the issue.
          For children between the ages of 18 and 18, we recommend that parents
          and guardians supervise their children&apos;s online activities and
          consider using parental control tools available from online services
          and software manufacturers to help provide a child-friendly online
          environment.
        </Paragraph>

        <H4 mt={5}>YOUR RIGHTS</H4>
        <Paragraph mb={5}>
          As a user, you possess the right to request access to, rectification
          of, or erasure of your personal information in our possession, and you
          can exercise these rights by reaching out to us through the contact
          details provided in our contact us page
        </Paragraph>
      </Container>
    </ShopLayout1>
  );
};

export default PrivacyPolicy;
